module.exports = __webpack_public_path__ + "static/media/bitkala (3).7fe8f573.png";